import { render } from "./Label.vue?vue&type=template&id=1839fd90&scoped=true"
import script from "./Label.vue?vue&type=script&lang=ts"
export * from "./Label.vue?vue&type=script&lang=ts"

import "./Label.vue?vue&type=style&index=0&id=1839fd90&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1839fd90"

export default script